import { zodResolver } from '@hookform/resolvers/zod'
import { Checkbox, DialogActions, DialogContent, DialogTitle, FormControlLabel, Grid, Stack, Typography } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import { Controller, useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { Button, ControlledTextField } from 'src/components/forms'
import { EntityWithIdFields } from 'src/types'
import { z } from 'zod'
import { HttpInstrumentoLCSLHPTI } from './api'
import { InstrumentoLCSLHPTIDTO, InstrumentoLCSLHPTIFields, InstrumentoLCSLHPTIFormData } from './types'

type Props = {
    item?: InstrumentoLCSLHPTIDTO
    sinCodPais: number
    onClose: () => void
}

const schema = z.object({
    [InstrumentoLCSLHPTIFields.CodPais]: z.number(),
    [InstrumentoLCSLHPTIFields.Nombre]: z.string().min(1, 'Requerido').max(100, 'Maximo 100 caracteres'),
    [InstrumentoLCSLHPTIFields.PermiteEditarNombre]: z.boolean()
})

function EditInstrumentoLCSLHPTIForm({ item, sinCodPais, onClose }: Props) {
    const isNew = !item
    const { control, handleSubmit } = useForm<InstrumentoLCSLHPTIFormData>({
        resolver: zodResolver(schema),
        defaultValues: {
            [InstrumentoLCSLHPTIFields.CodPais]: sinCodPais,
            [InstrumentoLCSLHPTIFields.Nombre]: item?.[InstrumentoLCSLHPTIFields.Nombre] ?? '',
            [InstrumentoLCSLHPTIFields.PermiteEditarNombre]:
                item?.[InstrumentoLCSLHPTIFields.PermiteEditarNombre] ?? false
        }
    })

    const onSubmitWrapper = () => {
        let mensajeError = 'No se pudo guardar'
        const promise = new Promise<void>((resolve, reject) => {
            handleSubmit(formData => {
                const request = isNew
                    ? HttpInstrumentoLCSLHPTI.insert(formData)
                    : HttpInstrumentoLCSLHPTI.update(item![EntityWithIdFields.Id], formData)

                request.then(() => { setTimeout(onClose, 500); resolve() }).catch(reject)
            }, () => { mensajeError = 'Revise el formulario'; reject(mensajeError) })()
        })
        toast.promise(promise, { success: 'Guardado', error: () => mensajeError, loading: 'Guardando' })

        return promise
    }

    return (
        <>
            <DialogTitle sx={{ pb: 0 }}>
                <Stack direction='row' spacing={1.5} alignItems='center'>
                    <EditIcon color='primary' />
                    <Typography variant='h6' fontWeight={600}>
                        {isNew ? 'Nuevo instrumento' : 'Editar instrumento'}
                    </Typography>
                </Stack>
            </DialogTitle>
            <DialogContent sx={{ pt: '24px !important', px: 5, pb: 4 }}>
                <Grid container spacing={4}>
                    <Grid item xs={12}>
                        <ControlledTextField control={control} name={InstrumentoLCSLHPTIFields.Nombre} label='Nombre' fullWidth />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Controller
                            control={control}
                            name={InstrumentoLCSLHPTIFields.PermiteEditarNombre}
                            render={({ field }) => (
                                <FormControlLabel
                                    control={<Checkbox checked={field.value} onChange={(_, checked) => field.onChange(checked)} />}
                                    label='Permite editar nombre'
                                />
                            )}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button variant='text' color='inherit' onClick={onClose}>Cancelar</Button>
                <Button variant='contained' color='primary' promise={onSubmitWrapper}>Guardar</Button>
            </DialogActions>
        </>
    )
}

export default EditInstrumentoLCSLHPTIForm
